import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';

export const UnauthorizedPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <>
            <SEOHead seo={{
                title: '403 — Access Denied | Arte Craft India',
                description: 'You do not have permission to access this page.',
                canonical: `${window.location.origin}/unauthorized`,
                noIndex: true,
            }} />

            <div style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '80px 20px',
                background: '#f5f8fc',
            }}>
                {/* Big code */}
                <div style={{
                    fontSize: '7rem',
                    fontWeight: 900,
                    lineHeight: 1,
                    background: 'linear-gradient(135deg, #C00000 0%, #e53e3e 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    letterSpacing: '-0.04em',
                }}>
                    403
                </div>

                {/* Divider */}
                <div style={{
                    width: 60,
                    height: 3,
                    borderRadius: 2,
                    background: 'linear-gradient(90deg, #C00000, #e53e3e)',
                    margin: '18px 0',
                }} />

                <h1 style={{
                    fontSize: '1.5rem',
                    fontWeight: 800,
                    color: '#1a202c',
                    margin: '0 0 10px',
                    textAlign: 'center',
                }}>
                    Access Denied
                </h1>

                <p style={{
                    fontSize: '0.95rem',
                    color: '#64748b',
                    margin: '0 0 36px',
                    textAlign: 'center',
                    maxWidth: 380,
                    lineHeight: 1.6,
                }}>
                    You don't have permission to view this page. Please log in with an account that has the required access.
                </p>

                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            padding: '10px 24px',
                            borderRadius: 8,
                            border: '1.5px solid #cbd5e1',
                            background: '#fff',
                            color: '#1E3A5F',
                            fontWeight: 700,
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                        }}
                    >
                        Go Back
                    </button>
                    <button
                        onClick={() => navigate('/login')}
                        style={{
                            padding: '10px 24px',
                            borderRadius: 8,
                            border: 'none',
                            background: 'linear-gradient(135deg, #1E3A5F 0%, #2E75B6 100%)',
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                        }}
                    >
                        Go to Login
                    </button>
                </div>
            </div>
        </>
    );
};
